import flow from 'lodash/flow';
import { withMedia } from 'react-media-query-hoc';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
export default flow(withAllhomesContext('watchlist', 'isIdentityLoading', 'updateWatchList', 'user', 'openSignUp', 'openSignIn'), withMedia);